export default "__VITE_ASSET__CTFtEXeR__"